// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper-transition[data-v-6bcf926d]{transition:all .2s}.accent-color-bg[data-v-6bcf926d]{background:#0d48e1;color:#fff}a.icon[data-v-6bcf926d]{cursor:pointer}.height60[data-v-6bcf926d]{height:60px}.width60[data-v-6bcf926d]{width:60px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
